export const LOGO_URL = '/logo.png'
